import '@styles/fonts.css';
import App from '@components/App';
import config from '@config';
import type { CurrentUserResponse } from '@platform2-lib/models/models';
import { fetchCurrentUser } from '@platform2-lib/sso';
import { getToken } from '@platform2-lib/token';
import { logOut } from '@utils';
import { StrictMode } from 'react';
import reactDom from 'react-dom/client';

const token = getToken(config.env);

if (!token) {
  logOut();
}

const rootId = 'octopus-root';
const rootElement = document.getElementById(rootId);

if (rootElement === null) {
  throw new Error(`Element with id '${rootId}' not found.`);
}

fetchCurrentUser(config.env, token)
  .then((response: CurrentUserResponse) => {
    const { data: user } = response;

    reactDom.createRoot(rootElement).render(
      <StrictMode>
        <App user={user} />
      </StrictMode>
    );
  })
  .catch((status: number) => {
    if (status === 401 || status === 403) {
      logOut();
    }
  });

// Accessibility: 'Enter' & 'Space' key navigation
rootElement.addEventListener('keydown', (event: KeyboardEvent) => {
  if (event.code === 'Enter') {
    event.preventDefault();

    if (
      event.target instanceof HTMLElement &&
      !event.target.dataset.ignoreGlobalKeystroke
    ) {
      event.target.click();
    }
  }
});
